export class SharedUtils {

    static inputValueIsEmpty(value: any | undefined): boolean {
        // we don't check for string here so it also works with arrays
        return (value === null || value === undefined || value.length === 0 || value === '' || value === 0);
    }

    static inputValueIsPresent(value: any | undefined): boolean {
        // we don't check for string here so it also works with arrays
        return !(value === null || value === undefined || value.length === 0 || value === '' || value === 0);
    }

    static breakString(text: string, separator: string) {
        let example: string = "Un esempio di stringa strana... Ciao. con il punto.  in vari punti."; 
        console.log("SHARED UTILS - Breaking a String... ORIGINAL: " + example + 
        "\n RESULT: " + example.replace("\b\d_[a-zA-Z]+_" + separator + "\ \b/g", separator + " "));
        return text.replace("\b\d_[a-zA-Z]+_" + separator + "\ \b/g", separator + " "); 
    }

    static removeSpecialChars(origin: string): string {
        let result: string = origin.replace(/[^a-zA-Z]/g , "");
        result = result.trim();
        result = result.toLowerCase();
        return result;
    }
    
/***********************************************
    static concatSets(set, ...iterables): any {
        for(const iterable of iterables) {
            for (const item of iterable) {
                set.add(item);
            }
        }
        return set;
    }

    static concatMaps(map, ...iterables): any {
        for(const iterable of iterables) {
            for(const item of iterable) {
                map.set(...item);
            }
        }
        return map;
    }
*************************************************/
}
